import React, { useRef, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

function CopyableItem({ text, name, intl }) {
  const [copySuccess, setCopySuccess] = useState('');
  const textAreaRef = useRef(null);

  function copyToClipboard(e) {
    textAreaRef.current.select();
    document.execCommand('copy');
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    e.target.focus();
    setCopySuccess(intl.formatMessage({ id: 'mainDialog.copy' }));
    setTimeout(() => {
      setCopySuccess('');
    }, 2000);
  }

  function openInNewTab(e) {
    window.open(text, '_blank');
  }

  return (
    <div className="share-view">
      <div className="row">
        <span className="col-sm-12">{name || text}</span>
      </div>
      <div className="row">
        <form className="share-view__link-item col-sm-10">
          <textarea
            className="share-view__link-item--input"
            ref={textAreaRef}
            defaultValue={text}
          />
        </form>
        {
        document.queryCommandSupported('copy') &&
        <div className="share-view__link-item col-sm-1">
            <Button className="share-view__link-item--btn" variant="link" size="sm" onClick={copyToClipboard}>
              <i className="far fa-copy" />
            </Button>
          <p className="share-view__link-item--copy-msg">
            {copySuccess}
          </p>
        </div>
      }
        <div className="share-view__link-item col-sm-1">
          <Button className="share-view__link-item--btn" variant="link" size="sm" onClick={openInNewTab}>
            <i className="fas fa-external-link-alt" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(CopyableItem);



// WEBPACK FOOTER //
// ./src/js/components/UMOShareLinkView/CopyableItem.jsx